import React, { Fragment, useState, useEffect } from "react";
import { Input, InputGroup, InputGroupAddon, Button, Label , Spinner } from "reactstrap";
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import ValidationGroup, { ValidatorMark } from "~/components/validation";

import Msg  from "~/components/messages";

import User from "~/services/user";

const Description = ({setReload})=> {

  const [hasTelegram , setHasTelegram] = useState(false);
  const [username    , setUsername]    = useState(false);
  const [loading     , setLoading]     = useState(false);
  const [errors      , setErrors]      = useState({});

  useEffect(async ()=> {
    const username = (await User.telegramProfile())?.username;
    setHasTelegram(Boolean(username));
    setUsername(username || "");
  }, []);

  const validation = ValidationGroup("JoinTelegram");

  const hasErrors = ()=> {

    const errorList = {
      ...validation("username", username),
    };
    setErrors(errorList);

    return Boolean(Object.values(errorList).length);
  }

  const setTelegram = (e)=> {
    e.stopPropagation();
    if(hasErrors()) return;
    setLoading(true);

    User.updateTelegramProfile({username})
      .then((message)=> {
        Msg.profileUpdated(message);
        setLoading(false);
        setHasTelegram(true);
        setReload(true);
      })
      .catch(setErrors)
      .finally(()=> setLoading(false));
  }

  return (
    <Fragment>
      <div className="description-overlay">
        <h5> Subscribe to our Telegram Channel </h5>
        <p> Stay connected with us and get access to exclusive bonuses plus a <strong>200</strong> points reward when subscribing. </p>

        <Label className="text-left m-t-30">
          { hasTelegram ? "Your telegram username" : "Please set your telegram username in order to claim your reward." }
        </Label>

        <InputGroup className={classNames({ 'is-invalid': errors.username})}>
          <Input type="text"
            value={username}
            placeholder="Your Telegram username"
            onClick={(e)=> e.stopPropagation()}
            onChange={(e)=> setUsername(e.target.value)}
            readOnly={hasTelegram}
            className={classNames({ 'is-invalid': errors.username})}
            />

          { !hasTelegram && (
            <InputGroupAddon addonType="prepend">
              <Button className="btn btn-info" onClick={setTelegram} disabled={loading}>
                { loading ? <Spinner size="sm" /> : "Save" }
              </Button>
            </InputGroupAddon>
          )}

        </InputGroup>
        <ValidatorMark val={username} name="username" validation={validation} errors={errors} textOnly={true} />

      </div>
      <Link className="btn action btn-primary" target="_blank" to={{pathname: "https://t.me/earndorado"}}>Subscribe</Link>
    </Fragment>
  );
};

export default Description;
